import { useCallback } from 'react';
import { useLazyQueryInterop } from '@confluence/apollo-relay-interop';
import { fg } from '@confluence/feature-gating';

import { LazyConfluenceSmartCreationModal } from './LazyConfluenceSmartCreationModal.ts';
import { ConfluenceSmartCreationModalQuery } from './ConfluenceSmartCreationModalQuery.ts';
import { type ConfluenceSmartCreationModalQuery as ConfluenceSmartCreationModalQueryResult } from './__types__/ConfluenceSmartCreationModalQuery.ts';

export const usePreloadSmartCreationModal = () => {
	const [preloadSmartCreationModalQuery] =
		useLazyQueryInterop<ConfluenceSmartCreationModalQueryResult>(ConfluenceSmartCreationModalQuery);

	return useCallback(() => {
		if (fg('aifc_create_enabled')) {
			preloadSmartCreationModalQuery();
			LazyConfluenceSmartCreationModal.preload();
		}
	}, [preloadSmartCreationModalQuery]);
};
